import { useQuery } from '@tanstack/react-query';
import { GET_HALLMARK_COMPOSITIONS } from '@/helpers/query-keys';
import { getHallmarkCompositions } from '@/services/qc.service';

export const useHallmarkCompositions = () => {
  return useQuery({
    queryKey: [GET_HALLMARK_COMPOSITIONS],
    queryFn: getHallmarkCompositions,
    staleTime: Infinity,
  });
};
